import { UsersView } from "@/features/admin/users/components/UsersView";

export function UsersPage() {
  return <UsersView />;
}
